export enum DescriptionMode {
  SINGLE = 'single', // 1 description
  SMALL = 'small', // 2 descriptions
  BIG = 'big', // more than 2 descriptions
}
